import {Link} from "react-router-dom";
import React from "react";
import {observer} from "mobx-react";
import PropTypes from 'prop-types'
import {stringContains} from "../../../../utils/utils";

const RouteOption = observer((props) => {
    const isActualRoute = stringContains(window.location.href, props.routeOrigin)
    return (
        <div
            onClick={event => {props.onClick(event)}}
            className={isActualRoute ? 'top-bar__option_active' : 'top-bar__option'}>

            <div className="top-bar__option__line"><div className="line"/></div>
            
            <Link to={props.link}>{props.title}</Link>
        </div>
    )
})

RouteOption.propTypes = {
    dropDown: PropTypes.bool,
    dropDownRouteList: PropTypes.arrayOf(PropTypes.shape({
        link: PropTypes.string,
        title: PropTypes.string
    }))
}

export default RouteOption